import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  createProductValidation,
  deleteProductValidation,
  getProductValidations,
  updateProductValidation,
} from "data/server_apis/commodityService";

const productValidationAdapter = createEntityAdapter({
  selectId: (productValidation) => productValidation.id,
});

export const getProductValidationsThunk = createAsyncThunk(
  "productValidations/getForProduct",
  async (id, { rejectWithValue }) => {
    try {
      return (await getProductValidations(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createProductValidationThunk = createAsyncThunk(
  "productValidations/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createProductValidation(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updateProductValidationThunk = createAsyncThunk(
  "productValidation/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateProductValidation(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const deleteProductValidationThunk = createAsyncThunk(
  "productValidation/delete",
  async (id, { rejectWithValue }) => {
    try {
      return (await deleteProductValidation(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const productValidationsSlice = createSlice({
  name: "productValidations",
  initialState: productValidationAdapter.getInitialState({
    status: {},
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProductValidationsThunk.pending, (state, action) => {
        state.status = { loading: "get" };
      })
      .addCase(getProductValidationsThunk.rejected, (state, action) => {
        state.status = { error: "get", errorMessage: action.payload?.message };
      })
      .addCase(getProductValidationsThunk.fulfilled, (state, action) => {
        state.status = { success: "get" };
        productValidationAdapter.setAll(state, action.payload);
      });

    builder
      .addCase(createProductValidationThunk.pending, (state, action) => {
        state.status = { loading: "create" };
      })
      .addCase(createProductValidationThunk.rejected, (state, action) => {
        state.status = {
          error: "create",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(createProductValidationThunk.fulfilled, (state, action) => {
        state.status = { success: "create" };
        productValidationAdapter.addOne(state, action.payload);
      });

    builder
      .addCase(updateProductValidationThunk.pending, (state, action) => {
        state.status = { loading: "update", id: action.meta.arg.id };
      })
      .addCase(updateProductValidationThunk.rejected, (state, action) => {
        state.status = {
          error: "update",
          errorMessage: action.payload?.message,
          id: action.meta.arg.id,
        };
      })
      .addCase(updateProductValidationThunk.fulfilled, (state, action) => {
        state.status = { success: "update" };
        productValidationAdapter.updateOne(state, {
          id: action.meta.arg.id,
          changes: action.payload,
        });
      });

    builder
      .addCase(deleteProductValidationThunk.pending, (state, action) => {
        state.status = { loading: "delete", id: action.meta.arg.id };
      })
      .addCase(deleteProductValidationThunk.rejected, (state, action) => {
        state.status = {
          id: action.meta.arg.id,
          error: "delete",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(deleteProductValidationThunk.fulfilled, (state, action) => {
        state.status = { success: "delete", id: action.meta.arg.id };
        productValidationAdapter.removeOne(state, action.meta.arg);
      });
  },
});
export const productValidationSelector = productValidationAdapter.getSelectors(
  (state) => state.productValidation
);
export const {} = productValidationsSlice.actions;

export default productValidationsSlice.reducer;
